const POPUP_TYPES = {
    SUBSCRIBE: {
        name: 'SubscribePopup',
        visibilityDelayAfterClose: 3 * 24,
        visibilityDelayAfterSubscribe: 14 * 24,
        visibilityDelayAfterInaction: 3,
        delayBeforeClose: 60000,
    },
};

export {
    POPUP_TYPES,
};
